<template>
  <layout>
    <template slot="header">
      Table settings
    </template>

    <template>
      <form-subheader class="px-4" style="cursor: pointer" @click="selectAll">
        Show columns
      </form-subheader>
      <v-list class="pa-0">
        <v-list-item
          v-for="(item, i) in localFields"
          :key="`item-${i}`"
          :ripple="false"
        >
          <v-list-item-avatar>
            <v-simple-checkbox
              :data-test-settings="item.text"
              color="primary"
              :ripple="false"
              v-model="item.selected"
            ></v-simple-checkbox>
          </v-list-item-avatar>
          <v-list-item-content>
            {{ item.text }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <template slot="footer">
      <v-spacer />
      <v-btn text :loading="false" @click.stop="close">
        cancel
      </v-btn>
      <v-btn color="primary" text :loading="false" @click.stop="apply">
        save
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import { mapState } from 'vuex';
import { cloneDeep } from '@apollo/client/utilities';
export default {
  name: 'tableSettings',
  components: {
    Layout
  },
  props: {
    fields: {
      type: [Array]
    },
    selected: {
      type: [Array]
    }
  },
  data: () => ({
    localFields: []
  }),
  methods: {
    apply() {
      this.$emit(
        'save',
        this.localFields.filter(i => i.selected).map(i => i.id)
      );
      this.close();
    },
    close() {
      this.$emit('close');
    },
    selectAll() {
      this.localFields = this.localFields.map(i => ({
        ...i,
        selected: true
      }));
    }
  },
  watch: {
    // selected() {
    //   this.localFields = this.fields.map(i => ({
    //     id: i.key,
    //     text: i.text,
    //     selected: this.selected.indexOf(i.key) > -1
    //   }));
    // }
  },
  created() {
    let fields = cloneDeep(this.fields);
    this.localFields = this.fields.map(i => ({
      id: i.key,
      text: i.text,
      selected: this.selected.indexOf(i.key) > -1
    }));
  },
  destroyed() {
    this.localFields = [];
  }
};
</script>

<style lang="sass"></style>
